export const homeHeroKeys = {
  all: ["home-hero"] as const,
  hero: (locale: string) => [...homeHeroKeys.all, locale] as const,
};

export const homeCategoriesKeys = {
  all: ["home-categories"] as const,
  categories: (locale: string) => [...homeCategoriesKeys.all, locale] as const,
};
